import React from 'react';
import { Link } from 'react-router-dom';
import { CONTACT, footerGroups } from '../data/navigation';
import { Wordmark } from './Wordmark';
export function Footer() {
  return <footer className="w-full bg-navy text-aluminum" data-id="element-10" data-mp="32nummremu92y">
      <div className="mx-auto max-w-shell px-5 py-14 lg:px-10 lg:py-20" data-id="element-11" data-mp="32pfeg99kbdx4">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.5fr)]" data-id="element-12" data-mp="36ooaxlvzlpwd">
          <div data-id="element-13" data-mp="3ueiknul0eyce">
            <Wordmark tone="light" variant="footer" data-id="element-14" data-mp="3ug3etj3ewf9q" />
            <p className="rp-measure mt-6 text-[14px] leading-relaxed text-aluminum" data-id="element-15" data-mp="3ud7hnwze1umc">
              High-rake CNC lathe holders, inserts, starter kits and application
              guidance for aluminum, copper and titanium.
            </p>
            <dl className="mt-8 space-y-3 text-[14px]" data-id="element-16" data-mp="3qcnjqr6zqmz5">
              <div className="flex flex-wrap items-baseline gap-2" data-id="element-17" data-mp="3qf9suv9j5ajh">
                <dt className="font-mono text-[10px] tracking-label text-aluminum/70" data-id="element-18" data-mp="29xm0kogz74j3">
                  PHONE
                </dt>
                <dd data-id="element-19" data-mp="2evxbl2j0bl2w">
                  <a href={CONTACT.phoneHref} data-analytics="phone-click" data-analytics-location="footer" className="font-mono text-white underline decoration-copper decoration-1 underline-offset-4 transition-colors duration-150 ease-precise hover:text-cta" data-id="element-20" data-mp="3l90lvqkngowm">
                    {CONTACT.phoneLabel}
                  </a>
                </dd>
              </div>
              <div className="flex flex-wrap items-baseline gap-2" data-id="element-21" data-mp="80xi63gl8rgz">
                <dt className="font-mono text-[10px] tracking-label text-aluminum/70" data-id="element-22" data-mp="335ujlmz7ril">
                  EMAIL
                </dt>
                <dd data-id="element-23" data-mp="huwg0q9mpp34">
                  <a href={CONTACT.emailHref} data-analytics="email-click" data-analytics-location="footer" className="text-white underline decoration-copper decoration-1 underline-offset-4 transition-colors duration-150 ease-precise hover:text-cta" data-id="element-24" data-mp="cu0g0nseen2z">
                    {CONTACT.email}
                  </a>
                </dd>
              </div>
              <div data-id="element-25" data-mp="yuz9nsi2n5jq">
                <dt className="font-mono text-[10px] tracking-label text-aluminum/70" data-id="element-26" data-mp="ys3egbxlyuyz">
                  MAILING ADDRESS
                </dt>
                <dd className="mt-1 text-aluminum" data-id="element-27" data-mp="18kiwtacthlke">{CONTACT.mailingAddress}</dd>
              </div>
            </dl>
          </div>

          <div className="grid grid-cols-2 gap-x-8 gap-y-10 sm:grid-cols-4" data-id="element-28" data-mp="1ckt2elwp69yq">
            {footerGroups.map(group => <nav key={group.label} aria-label={`Footer ${group.label}`} data-id="element-29" data-mp="1hiun1b9ruhcb">
                <h2 className="font-mono text-[10px] tracking-label text-copper" data-id="element-30" data-mp="1ml3f85etlfdd">
                  {group.label.toUpperCase()}
                </h2>
                <ul className="mt-4 space-y-2.5" data-id="element-31" data-mp="3ob55u0ppux42">
                  {group.links.map(link => <li key={link.href} data-id="element-32" data-mp="3ta8c1ohfn9dm">
                      <Link to={link.href} className="inline-block py-1 text-[13.5px] leading-snug text-aluminum transition-colors duration-150 ease-precise hover:text-white" data-id="element-33" data-mp="3tb189virmghi">
                        {link.label}
                      </Link>
                    </li>)}
                </ul>
              </nav>)}
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-4 border-t border-white/10 pt-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-34" data-mp="1wlvzlu3anzzt">
          <p className="text-[12.5px] text-aluminum/80" data-id="element-35" data-mp="2pbuu4509cpbv">
            © 2026 Robertson Precision, Inc. All rights reserved.
          </p>
          <ul className="flex items-center gap-6" data-id="element-36" data-mp="2kc06cabs4fv1">
            <li data-id="element-37" data-mp="2fegoz1jsbmyv">
              <Link to="/privacy/" className="text-[12.5px] text-aluminum/80 transition-colors duration-150 ease-precise hover:text-white" data-id="element-38" data-mp="2fezvzn7wcqy4">
                Privacy
              </Link>
            </li>
            <li data-id="element-39" data-mp="1414hmgotgm7y">
              <Link to="/cookie-policy/" className="text-[12.5px] text-aluminum/80 transition-colors duration-150 ease-precise hover:text-white" data-id="element-40" data-mp="141e5nyqawjb0">
                Cookie Policy
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </footer>;
}